export const BASIC = 'BASIC';
export const SPECIAL = 'SPECIAL';
